;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { useSyncExternalStore } from 'react';
const TOP_OFFSET = 30;
const subscribe = (onStoreChange: () => void): (() => void) => {
  window.addEventListener('scroll', onStoreChange);
  return () => {
    window.removeEventListener('scroll', onStoreChange);
  };
};
const getSnapshot = (): boolean => window.scrollY >= TOP_OFFSET;
const getServerSnapshot = (): boolean => false;

// Reading the scroll position through useSyncExternalStore also picks up a page
// that loads already scrolled, which the previous effect handled with a separate
// initial setState.
const useScrollDetect = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
export default useScrollDetect;